import script from "./GroupLevelSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupLevelSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./GroupLevelSidebar.vue?vue&type=style&index=0&id=3ffeb80e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ffeb80e"]])

export default __exports__